// components/SummaryScreen.jsx
import React from "react";
import styles from "./Summaryscreen.module.css";
import { Link } from "react-router-dom";
import { Globalimages } from "../Imagesreusable";
import PatientCard from "../SymptomsCheckerFlow/PatientCard";

const SummaryScreen = ({
  title = "Awesome 👍 Here's what I've got about you",
  cardTitle = "Everything looks good?",
  cardSubtitle = "Your BMI will be calculated in the next step to guide your health plan",
  editLabel = "Edit Details",
  confirmLabel = "Confirm & Continue",
  items = [],
  confirmLink,
  onEdit,
  patient,
  heightCm,   // ← add
  weightKg,
  onConfirm,
  hideHeader = false,
}) =>{ 
  // console.log("Rendering SummaryScreen with items:", heightCm, weightKg, patient) 
  return (
    <>
    {!hideHeader && (<div className={styles.headerBar}>
      <img
        src={Globalimages.logo}
        alt="Avexa Logo"
        className={styles.logo}
      />
    </div>)}
    <div className={styles.wrapper}>

      <h2 className={`ava-text-subheading ${styles.title}`}>{title}</h2>

      <div className={styles.contentRow}>
        {/* icon + "Age Group: 26–35" */}
        <ul className={styles.list}>
          {items.map((item, i) => (
            <li key={i} className={styles.row}>
              {item.icon && <span className={styles.icon}>{item.icon}</span>}
              <span className={`ava-text-body ${styles.line}`}>
                {item.label}: {item.value}
              </span>
            </li>
          ))}
        </ul>
        {/* Right- Patient card details */}
        {/* {patient&&(
          <div className={styles.rightCol}>
            {
              heightCm && weightKg ? (
                <PatientCard patient={{...patient, heightCm, weightKg}} size={120} />
              ) : ( 
                <PatientCard patient={patient} size={120} />
              )
            }
          </div>
        )} */}
         {patient && (
          <div className={styles.rightCol}>
           <PatientCard patient={{ ...patient, heightCm, weightKg }} size={100} />
          </div>
        )}
      </div>

      <div className={styles.card}>
        <p className={`ava-text-subheading ${styles.cardTitle}`}>{cardTitle}</p>
        <p className={`ava-text-caption ${styles.cardSubtitle}`}>{cardSubtitle}</p>
        <div className={styles.actions}>
          <button className={`ava-text-body ${styles.editBtn}`} onClick={onEdit} type="button">
            {editLabel}
          </button>
          {/* <button className={styles.confirmBtn} onClick={onConfirm} type="button" href={confirmLink}>
          {confirmLabel}
        </button> */}
          <Link className={`btn-primary`} to={confirmLink} onClick={onConfirm}>
            {confirmLabel}
          </Link>

        </div>
      </div>

    </div>
  </>
  )
};

export default SummaryScreen;